import React from 'react';
import { Search, MoreVertical, Home, ArrowLeft, Files } from 'lucide-react';
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";

interface WorkStation {
  id: string;
  title: string;
}

const SavedInstructionsPage: React.FC = () => {
  const workStations: WorkStation[] = [
    { id: '1', title: 'QIT Line Work Instructions 1' },
    { id: '2', title: 'QIT Line Work Instructions 2' },
    { id: '3', title: 'QIT Line Work Instructions 3' },
    { id: '4', title: 'QIT Line Work Instructions 4' },
    { id: '5', title: 'QIT Line Work Instructions 5' },
  ];

  return (
    <div className="min-h-screen bg-blue-900 pb-20">
      {/* Header */}
      <div className="p-4 "><img src={digitalOceanImageUrl("new%20logos/Asset%204.png")} alt="KMC Logo" className="w-16 h-auto ml-auto h-24 w-27 " />  </div>
      <div className="p-6 flex justify-between items-center">
        <h1 className="text-white text-lg font-medium">
          12 Meter EVS 2024 | Work Instructions
        </h1>
      </div>

      {/* Search Bar */}
      <div className="px-6 mb-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Search for an instruction document..."
            className="w-full py-3 px-4 pr-10 rounded-full"
          />
          <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
      </div>

      {/* Instructions Card */}
      <div className="bg-white rounded-3xl">
      <div className=" mb-6 bg-white rounded-full p-6">
      <div className="bg-white rounded-xl border p-8 flex justify-between items-center">
          <div>
            <h2 className="text-blue-900 text-xl font-bold mb-2">QIT Line Instructions</h2>
            <p className="text-gray-600 text-sm max-w-xs">
              Find clear, step-by-step instructions to help you complete your tasks efficiently and accurately.
            </p>
          </div>
          <img src={digitalOceanImageUrl("assets/images/machineimage.jpg")} alt="12M EVS" className="w-27 h-24" />
        </div>
      </div>

      {/* Work Stations Section */}
      <div className="px-6 py-6">
        <h3 className="text-blue-900 font-bold mb-4">Work Stations</h3>
        <div className="space-y-3">
          {workStations.map((station) => (
            <div 
              key={station.id}
              className="bg-sky-200 font-semibold rounded-lg p-4 flex justify-between items-center"
            >
              <span className="text-gray-900">{station.title}</span>
              <button className="p-1">
                <MoreVertical className="w-5 h-5 text-gray-600" />
              </button>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white">
        <div className="flex justify-around py-4">
          <button className="flex flex-col items-center text-blue-900">
            <ArrowLeft className="w-6 h-6" />
            <span className="text-xs mt-1">Back</span>
          </button>
          <button className="flex flex-col items-center text-blue-900">
            <Home className="w-6 h-6" />
            <span className="text-xs mt-1">Home</span>
          </button>
          <button className="flex flex-col items-center text-blue-900">
            <Files className="w-6 h-6" />
            <span className="text-xs mt-1">Saved</span>
          </button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default SavedInstructionsPage;